<template>
  <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
    <a-form-item ref="is_invite_store_check" label="邀请注册门店" name="is_invite_store_check">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-radio-group v-model:value="form.is_invite_store_check">
            <a-radio :value="0">
              无需验证手机号
            </a-radio>
            <a-radio :value="1">
              验证手机号
            </a-radio>
          </a-radio-group>
          <a-tooltip placement='right'>
            <template #title>1.无需验证手机号：通过经销商的邀请码注册门店时，填写手机号不需要短信验证
              2.验证手机号：通过经销商的邀请码注册门店时，填写手机号需要短信验证手机号
            </template>
            <QuestionCircleOutlined class="s_c376" />
          </a-tooltip>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item ref="is_invite_dealer_check" label="邀请注册经销商" name="is_invite_dealer_check">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-radio-group v-model:value="form.is_invite_dealer_check">
            <a-radio :value="0">
              无需验证手机号
            </a-radio>
            <a-radio :value="1">
              验证手机号
            </a-radio>
          </a-radio-group>
          <a-tooltip placement='right'>
            <template #title>1.无需验证手机号：通过经销商的邀请码注册经销商时，填写手机号不需要短信验证
              2.验证手机号：通过经销商的邀请码注册经销商时，填写手机号需要短信验证手机号
            </template>
            <QuestionCircleOutlined class="s_c376" />
          </a-tooltip>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item ref="is_invite_dealer_check" label="注册门店方式" name="is_invite_dealer_check">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-checkbox-group v-model:value="form.register_store_type">
            <a-checkbox value="1">邀请注册</a-checkbox>
            <a-checkbox value="2">手动添加</a-checkbox>
          </a-checkbox-group>
          <a-tooltip placement='right'>
            <template #title>
              1.邀请注册：经销商和经销商业务员只能通过邀请码来添加门店
              <br/>
              2.手动添加：经销商和经销商业务员可以根据门店资料手动添加门店
            </template>
            <QuestionCircleOutlined class="s_c376" />
          </a-tooltip>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 8, offset: 2 }">
      <a-button type="primary" @click="onSubmit">
        保存
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { ref, reactive, toRefs, inject, onMounted } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import { editset, getNowDealerSet } from "@/api/dealer";
// 初始化默认筛选项数值
let defForm = {
  is_invite_dealer_check: 1,
  is_invite_store_check: 1,
  register_store_type: ["1"],
};
export default {
  components: {
    QuestionCircleOutlined,
  },
  props: {},
  setup(props, { emit }) {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
    });
    const ruleForm = ref();
    const getDealerSet = async () => {
      let res = await getNowDealerSet().then((res) => res.data);
      console.log(res);
      if (iscode(res)) {
        form.value = res.data;
      } else {
        message.error(res.msg);
      }
    };
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          const hide = message.loading("正在加载中...", 0);
          let res = await editset({ ...form.value }).then((res) => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            getDealerSet();
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    onMounted(() => {
      getDealerSet();
    });
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
    };
  },
};
</script>
